import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const CloseCircleSolidIcon = forwardRef<SVGSVGElement, IconProps>(function CloseCircleSolidIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 0C4.041 0 0 4.041 0 9C0 13.959 4.041 18 9 18C13.959 18 18 13.959 18 9C18 4.041 13.959 0 9 0ZM12.024 11.07C12.285 11.331 12.285 11.763 12.024 12.024C11.889 12.159 11.718 12.222 11.547 12.222C11.376 12.222 11.205 12.159 11.07 12.024L9 9.954L6.93 12.024C6.795 12.159 6.624 12.222 6.453 12.222C6.282 12.222 6.111 12.159 5.976 12.024C5.715 11.763 5.715 11.331 5.976 11.07L8.046 9L5.976 6.93C5.715 6.669 5.715 6.237 5.976 5.976C6.237 5.715 6.669 5.715 6.93 5.976L9 8.046L11.07 5.976C11.331 5.715 11.763 5.715 12.024 5.976C12.285 6.237 12.285 6.669 12.024 6.93L9.954 9L12.024 11.07Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
